import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"

import Obr from "../images/katherine-volkovski-Q_MJjEN14uk-unsplash.jpg"

const SecondPage = () => (
  <Layout>
    <SEO title="Hybrid kukurice Zirkonia" />
    <section className="text-gray-700 body-font overflow-hidden">
      <div className="container px-5 py-24 mx-auto">
        <div className="lg:w-4/5 mx-auto flex flex-wrap">
          <div className="lg:w-1/2 w-full lg:pr-10 lg:py-6 mb-6 lg:mb-0">
            <h2 className="text-sm title-font text-gray-500 tracking-widest">
              FAO 260
            </h2>
            <h1 className="text-gray-900 text-3xl title-font font-medium mb-4">
              Zirkonia
            </h1>
            <div className="flex mb-4">
              <span className="flex-grow text-indigo-500 border-b-2 border-indigo-500 py-2 text-lg px-1">
                Odporúčania pre pestovateľov
              </span>
            </div>
            <p className="leading-relaxed text-justify mb-4">
              Hybrid ZIRKONIA je vzhľadom na svoju skorosť a plasticitu aj v
              suchších podmienkach vhodný pre pestovanie na siláž pre zemiakovú
              oblasť a pre chladnú časť repnej oblasti s možnosťou skoršieho
              zberu v tejto oblasti. Vzhľadom na vyšší podiel suchých šúľkov
              poskytuje siláž o vyššej stráviteľnosti, čo je možné využiť aj pre
              kŕmenie vysokoúžitkových dojníc. Do úvahy prichádza hlavne v
              repnej oblasti aj alternatívne využitie na zrno, CCM a LKS, čo
              zvýrazňuje vyššiu univerzálnosť hybrida. Hybrid vzhľadom na väčšie
              zrno osiva má dostatok zásobných látok na intenzívnejší počiatočný
              štart a rýchlejšie zapojenie porastu aj na menej homogénnych
              pôdach.
            </p>
            <div className="flex border-t border-gray-300 py-2">
              <span className="text-gray-500">Typ hybridu</span>
              <span className="ml-auto text-gray-900">Tc</span>
            </div>
            <div className="flex border-t border-gray-300 py-2">
              <span className="text-gray-500">Typ zrna</span>
              <span className="ml-auto text-gray-900">medzityp</span>
            </div>

            <div className="flex py-2">
              <span className="title-font font-medium text-2xl text-gray-900">
                Organizácia porastu:
              </span>
            </div>
            <div className="flex border-t border-gray-300 py-2">
              <span className="text-gray-500">
                Pre pestovanie v repnej oblasti na siláž
              </span>
              <span className="ml-auto text-gray-900">
                95 000
                <br />
                <span className="text-xs">rastlín na ha</span>
              </span>
            </div>
            <div className="flex border-t border-gray-300 py-2 mb-6">
              <span className="text-gray-500">
                Pre pestovanie v zemiakovej oblasti na siláž
              </span>
              <span className="ml-auto text-gray-900">
                100 000
                <br />
                <span className="text-xs">rastlín na ha</span>
              </span>
            </div>
            <div className="flex border-t border-gray-300 py-2 mb-6">
              <span className="text-gray-500">
                Pre pestovanie na zrno, CCM a LKS v repnej oblasti
              </span>
              <span className="ml-auto text-gray-900">
                85 000
                <br />
                <span className="text-xs">rastlín na ha</span>
              </span>
            </div>

            <div className="flex py-2">
              <span className="title-font font-medium text-2xl text-gray-900">
                Hospodárske vlastnosti:
              </span>
            </div>

            <div className="flex border-gray-300">
              <div className="p-2  w-full">
                <div className="bg-gray-200 rounded flex p-4 h-full items-center">
                  <svg
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="3"
                    className="text-indigo-500 w-6 h-6 flex-shrink-0 mr-4"
                    viewBox="0 0 24 24"
                  >
                    <path d="M22 11.08V12a10 10 0 11-5.93-9.14"></path>
                    <path d="M22 4L12 14.01l-3-3"></path>
                  </svg>
                  <span className="title-font font-medium">
                    Vhodnosť pre pestovanie kukurice na siláž v Zemiakovej
                    oblasti až po Repnú oblasť
                  </span>
                </div>
              </div>
            </div>

            <div className="flex border-t border-gray-300">
              <div className="p-2  w-full">
                <div className="bg-gray-200 rounded flex p-4 h-full items-center">
                  <svg
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="3"
                    className="text-indigo-500 w-6 h-6 flex-shrink-0 mr-4"
                    viewBox="0 0 24 24"
                  >
                    <path d="M22 11.08V12a10 10 0 11-5.93-9.14"></path>
                    <path d="M22 4L12 14.01l-3-3"></path>
                  </svg>
                  <span className="title-font font-medium">
                    Relatívne vyšší podiel šúľkov{" "}
                  </span>
                </div>
              </div>
            </div>

            <div className="flex border-t border-gray-300">
              <div className="p-2  w-full">
                <div className="bg-gray-200 rounded flex p-4 h-full items-center">
                  <svg
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="3"
                    className="text-indigo-500 w-6 h-6 flex-shrink-0 mr-4"
                    viewBox="0 0 24 24"
                  >
                    <path d="M22 11.08V12a10 10 0 11-5.93-9.14"></path>
                    <path d="M22 4L12 14.01l-3-3"></path>
                  </svg>
                  <span className="title-font font-medium">
                    Vyššia stráviteľnosť silážnej hmoty
                  </span>
                </div>
              </div>
            </div>

            <div className="flex border-t border-gray-300">
              <div className="p-2  w-full">
                <div className="bg-gray-200 rounded flex p-4 h-full items-center">
                  <svg
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="3"
                    className="text-indigo-500 w-6 h-6 flex-shrink-0 mr-4"
                    viewBox="0 0 24 24"
                  >
                    <path d="M22 11.08V12a10 10 0 11-5.93-9.14"></path>
                    <path d="M22 4L12 14.01l-3-3"></path>
                  </svg>
                  <span className="title-font font-medium">
                    Plasticita aj v suchších podmienkach
                  </span>
                </div>
              </div>
            </div>

            <div className="flex border-t border-gray-300">
              <div className="p-2  w-full">
                <div className="bg-gray-200 rounded flex p-4 h-full items-center">
                  <svg
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="3"
                    className="text-indigo-500 w-6 h-6 flex-shrink-0 mr-4"
                    viewBox="0 0 24 24"
                  >
                    <path d="M22 11.08V12a10 10 0 11-5.93-9.14"></path>
                    <path d="M22 4L12 14.01l-3-3"></path>
                  </svg>
                  <span className="title-font font-medium">
                    Rýchlejší nárast sušiny šúľkov
                  </span>
                </div>
              </div>
            </div>
          </div>
          <img
            alt="Hybrid kukurice Zirkonia"
            className="lg:w-1/2 w-full lg:h-auto h-64 object-cover object-center rounded"
            src={Obr}
          />
        </div>
      </div>
    </section>

    <div className="lg:w-2/3 w-full mx-auto overflow-auto py-4 mb-6">
      <h2 className="text-2xl text-gray-900 text-center font-medium leading-none py-4 mb-6 mt-2">
        Výpis výsledkov štátnych odrodových skúšok SR v roku 2009 - 2010
        (priemer lokalít):
      </h2>

      <table className="table-auto w-full text-left whitespace-no-wrap py-2">
        <tbody>
          <tr>
            <td
              className="px-4 py-3 title-font tracking-wider font-medium text-gray-900 text-sm bg-gray-400 rounded-tl rounded-bl border-2"
              rowspan="2"
            >
              Hybrid
            </td>
            <td
              className="px-4 py-3 title-font tracking-wider font-medium text-gray-900 text-sm bg-gray-400 rounded-tl rounded-bl border-2"
              colspan="3"
            >
              Úroda suchej hmoty (t/ha)
            </td>
            <td
              className="px-4 py-3 title-font tracking-wider font-medium text-gray-900 text-sm bg-gray-400 rounded-tl rounded-bl border-2"
              colspan="3"
            >
              Úroda suchých šúľkov (t/ha)
            </td>
          </tr>
          <tr>
            <td className="px-4 py-3 title-font tracking-wider font-medium text-gray-900 text-sm bg-gray-400 rounded-tl rounded-bl border-2">
              2009
            </td>
            <td className="px-4 py-3 title-font tracking-wider font-medium text-gray-900 text-sm bg-gray-400 rounded-tl rounded-bl border-2">
              2010
            </td>
            <td className="px-4 py-3 title-font tracking-wider font-medium text-gray-900 text-sm bg-gray-400 rounded-tl rounded-bl border-2">
              Priemer
            </td>
            <td className="px-4 py-3 title-font tracking-wider font-medium text-gray-900 text-sm bg-gray-400 rounded-tl rounded-bl border-2">
              2009
            </td>
            <td className="px-4 py-3 title-font tracking-wider font-medium text-gray-900 text-sm bg-gray-400 rounded-tl rounded-bl border-2">
              2010
            </td>
            <td className="px-4 py-3 title-font tracking-wider font-medium text-gray-900 text-sm bg-gray-400 rounded-tl rounded-bl border-2">
              Priemer
            </td>
          </tr>
          <tr>
            <td className="px-4 py-3">ZIRKONIA</td>
            <td className="bg-gray-100 px-4 py-3 ">25,1</td>
            <td className="bg-gray-100 px-4 py-3 ">16,9</td>
            <td className="bg-gray-100 px-4 py-3 ">21,0</td>
            <td className="bg-gray-100 px-4 py-3 ">9,28</td>
            <td className="bg-gray-100 px-4 py-3 ">7,30</td>
            <td className="bg-gray-100 px-4 py-3 ">8,29</td>
          </tr>
          <tr>
            <td className="px-4 py-3 bg-gray-300">ARRIGO - K</td>
            <td className="px-4 py-3 bg-gray-300">21,5</td>
            <td className="px-4 py-3 bg-gray-300">15,4</td>
            <td className="px-4 py-3 bg-gray-300">18,5</td>
            <td className="px-4 py-3 bg-gray-300">8,71</td>
            <td className="px-4 py-3 bg-gray-300">7,22</td>
            <td className="px-4 py-3 bg-gray-300">7,97</td>
          </tr>
          <tr>
            <td className="px-4 py-3 bg-gray-200">KARACHO - K</td>
            <td className="px-4 py-3 bg-gray-200">26,1</td>
            <td className="px-4 py-3 bg-gray-200">15,8</td>
            <td className="px-4 py-3 bg-gray-200">21,0</td>
            <td className="px-4 py-3 bg-gray-200">8,61</td>
            <td className="px-4 py-3 bg-gray-200">7,17</td>
            <td className="px-4 py-3 bg-gray-200">7,89</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div className="lg:w-2/3 w-full mx-auto overflow-auto py-4 mb-6">
      <h2 className="text-2xl text-gray-900 text-center font-medium leading-none py-4 mb-6 mt-2">
        Výpis výsledkov štátnych odrodových skúšok SR v roku 2009 z Beluše
        (repná oblasť):
      </h2>

      <table className="table-auto w-full text-left whitespace-no-wrap py-2">
        <thead>
          <tr>
            <th className="px-4 py-3 title-font tracking-wider font-medium text-gray-900 text-sm bg-gray-400 rounded-tl rounded-bl">
              HYBRID
            </th>
            <th className="px-4 py-3 title-font tracking-wider font-medium text-gray-900 text-sm bg-gray-400">
              Úroda suchej hmoty (t/ha)
            </th>
            <th className="px-4 py-3 title-font tracking-wider font-medium text-gray-900 text-sm bg-gray-400">
              Úroda suchých šúľkov (t/ha)
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="px-4 py-3 ">ZIRKONIA</td>
            <td className="bg-gray-100 px-4 py-3 ">38,00</td>
            <td className="bg-gray-100 px-4 py-3">10,82</td>
          </tr>
          <tr>
            <td className="px-4 py-3 bg-gray-300">ARRIGO - K</td>
            <td className="bg-gray-300 px-4 py-3 ">33,60</td>
            <td className="px-4 py-3 bg-gray-300">10,68</td>
          </tr>
          <tr>
            <td className="px-4 py-3 bg-gray-200">KARACHO - K</td>
            <td className="bg-gray-200 px-4 py-3 ">37,40</td>
            <td className="px-4 py-3 bg-gray-200">8,97</td>
          </tr>
        </tbody>
      </table>
    </div>
  </Layout>
)

export default SecondPage
